import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api, Extraction } from '../api/client';
import EmailDetailComp from '../components/EmailDetail';
import AiAnalysisPanel from '../components/AiAnalysisPanel';

const IconArrowLeft = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>
  </svg>
);

const ExtractionDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [extraction, setExtraction] = useState<Extraction | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<'email' | 'ai'>('email');

  useEffect(() => {
    if (!id) return;
    api.getExtraction(id)
      .then((data) => { setExtraction(data); setLoading(false); })
      .catch((err) => {
        setError(err instanceof Error ? err.message : 'Failed to load extraction');
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div style={{ padding: '32px' }}>
        <div className="skeleton" style={{ height: 20, width: 120, marginBottom: 24 }} />
        <div className="card skeleton" style={{ height: 400 }} />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '32px' }}>
        <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 'var(--radius)', padding: '16px', color: '#dc2626' }}>
          {error}
        </div>
      </div>
    );
  }

  if (!extraction) return null;

  return (
    <div style={{ padding: '24px' }} className="anim-fadeUp">
      {/* Back + header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
        <button className="btn-ghost" onClick={() => navigate('/extractions')} style={{ padding: '6px 12px' }}>
          <IconArrowLeft /> Back
        </button>
        <div style={{ height: 20, width: 1, background: 'var(--border)' }} />
        <span style={{ fontSize: '13px', color: 'var(--text-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {extraction.subject || '(No Subject)'}
        </span>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '2px', marginBottom: '20px', background: 'var(--card)', borderRadius: 'var(--radius)', padding: '4px', border: '1px solid var(--border)', width: 'fit-content' }}>
        {(['email', 'ai'] as const).map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '6px 20px',
              borderRadius: '7px',
              border: 'none',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
              background: activeTab === tab ? 'var(--accent)' : 'transparent',
              color: activeTab === tab ? '#fff' : 'var(--text-2)',
              transition: 'all .15s',
            }}
          >
            {tab === 'email' ? '📧 Email' : '🤖 AI Analysis'}
          </button>
        ))}
      </div>

      {activeTab === 'email' ? (
        <EmailDetailComp extraction={extraction} />
      ) : (
        <AiAnalysisPanel extractionId={extraction.id} />
      )}
    </div>
  );
};

export default ExtractionDetail;
